import { z } from 'zod'
import { zId, zIdNullable } from '../common'
import { zAdminRole } from '../enums'

export const zAdmin = z.object({
  id: zId,
  email: z.string(),
  role: zAdminRole,
  // null for a super_admin (sees all sites).
  siteId: zIdNullable.optional().default(null),
})
export type Admin = z.infer<typeof zAdmin>

// POST /session → 201 { token, admin }. There is no "me" endpoint: the admin
// object is persisted alongside the token and reread at boot. The API doc
// lists the admin fields flat next to `token`; accept both the nested and the
// flat shape and normalize to { token, admin }.
export const zSession = z.preprocess(
  (raw) => {
    if (raw && typeof raw === 'object' && !('admin' in raw) && 'email' in raw) {
      const { token, ...admin } = raw as Record<string, unknown>
      return { token, admin }
    }
    return raw
  },
  z.object({
    token: z.string(),
    admin: zAdmin,
  }),
)
export type Session = z.infer<typeof zSession>
